import { i18n } from '@fs/zion-locale'

export default {
  sectionTitle: () => i18n.t('metadata.section.title', 'Details'),
  archivalReferenceNumber: () => i18n.t('metadata.archivalReferenceNumber', 'Archival Reference Number'),
  imageGroupNumber: () => i18n.t('metadata.imageGroupNumber', 'Image Group Number'),
  cancel: () => i18n.t('edit-index.cancel.button', 'Cancel'),
  citation: () => i18n.t('metadata.citation', 'Citation'),
  citationText_ImageNumber: (number, totalNumber) =>
    i18n.t('metadata.citationText_ImageNumber', 'image {number} of {totalNumber}', { number, totalNumber }),
  citationText_Images: () => i18n.t('metadata.citationText_Images', 'images'),
  copyAll: () => i18n.t('metadata.copyAll', 'Copy All'),
  copyFailure: () => i18n.t('metadata.copyFailure', 'Failed to copy text to clipboard.'),
  copySuccess: (text) => i18n.t('metadata.copySuccess', '{text} copied to clipboard.', { text }),
  copyToClipboard: (fieldName) => i18n.t('metadata.copyToClipboard', 'Copy {fieldName} to clipboard', { fieldName }),
  creator: () => i18n.t('metadata.creator', 'Creator'),
  creatorPlaceholder: () => i18n.t('metadata,creatorPlaceholder', 'Add a creator'),
  custodian: () => i18n.t('metadata.custodian', 'Custodian'),
  everything: () => i18n.t('metadata.everything', 'Everything'),
  filmItemNotes: () => i18n.t('metadata.filmItemNotes', 'Film Item Notes'),
  glossary: {
    archivalReferenceNumber: () =>
      i18n.t(
        'metadata.glossary.archivalReferenceNumber',
        'An identifier a custodian or archive uses to keep track of the record.'
      ),
    citation: () =>
      i18n.t(
        'metadata.glossary.citation',
        "A summary of the record's metadata to be used for referencing the image group."
      ),
    creator: () =>
      i18n.t('metadata.glossary.creator', 'The organization, government, or other entity that created the record.'),
    custodian: () =>
      i18n.t(
        'metadata.glossary.custodian',
        'The organization, government, or other entity that currently owns the record.'
      ),
    date: () =>
      i18n.t('metadata.glossary.date', 'The year or date range from when the record or records were created.'),
    filmItemNotes: () => i18n.t('metadata.glossary.filmItemNotes', 'Additional information about the film item.'),
    imageGroupNumber: () =>
      i18n.t(
        'metadata.glossary.imageGroupNumber',
        "The image group's unique identification number, also known as a Digital Genealogical Society (DGS) number."
      ),
    imagesIndexed: () =>
      i18n.t('metadata.glossary.imagesIndexed', 'The number of images in the image group that have been indexed.'),
    language: () => i18n.t('metadata.glossary.language', 'The language the record is written in.'),
    title: () =>
      i18n.t('metadata.glossary.title', 'Contains the place, record type, and date of the records in the image group.'),
    volume: () => i18n.t('metadata.glossary.volume', 'Typically, the book number within a larger set of books.'),
  },
  indexed: () => i18n.t('metadata.imagesIndexed', 'Images Indexed'),
  indexedRecords: () => i18n.t('metadata.indexedRecords', 'View Indexed Records'),
  indexedTotal: (icon, indexed, total, percent) =>
    i18n.t('metadata.imagesIndexedTotal', '{icon} {indexed} of {total} images ({percent}%)', {
      icon,
      indexed,
      total,
      percent,
    }),
  itemNumberTextForGroupID: (idx, total) =>
    i18n.t('metadata.itemNumberTextForGroupIDLabel', '(Item {idx} of {total})', { idx, total }),
  language: () => i18n.t('metadata.language', 'Language'),
  multiValueHelpText: () =>
    i18n.t('metadata.multiValueHelpText', 'If multiple values exist, list each value on its own line.'),
  parentGroups: () => i18n.t('metadata.parentGroups', 'Parent Groups'),
  selectAllCreators: () => i18n.t('metadata.selectAllCreators', 'Select all Creators'),
  title: () => i18n.t('metadata.title', 'Title'),
  titleNumber: () => i18n.t('metadata.titleNumber', 'Title Number'),
  volume: () => i18n.t('metadata.volume', 'Volume'),

  // Citation Button extras:
  citationOverlayHeading: () =>
    i18n.t('IndexExploreHeader.Citation.Overlay.GroupNumberExplanation.heading', 'Film and Image Group Number'),
  citationOverlayTitle: () => i18n.t('IndexExploreHeader.Citation.Overlay.Title', 'Citation'),
  groupNumberExplanation: () =>
    i18n.t(
      'IndexExploreHeader.Citation.Overlay.GroupNumberExplanation.data',
      'Film numbers were used for microfilms, but with immediate digitalization of records, FamilySearch now uses Group Numbers'
    ),
  learnMore: () => i18n.t('IndexExploreHeader.Citation.Overlay.GroupNumberExplanation.learnMore', 'Learn More'),
  filmNumber: () => i18n.t('IndexExploreHeader.Citation.Overlay.GroupNumberExplanation.filmNumber', 'Film Number'),
}
